import { render, staticRenderFns } from "./VerifyOrganization.vue?vue&type=template&id=8f05a3ac&scoped=true&"
import script from "./VerifyOrganization.vue?vue&type=script&lang=js&"
export * from "./VerifyOrganization.vue?vue&type=script&lang=js&"
import style0 from "./VerifyOrganization.vue?vue&type=style&index=0&id=8f05a3ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f05a3ac",
  null
  
)

export default component.exports